package org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Resources

@Page("/kids/ride_to_read/class_2/story")
@Composable
fun StoryPage() {
    BlogLayout(
        PageProperties(
            "Story",
            ""
        ),
        BlogProperties("Ride To Reader", "Story")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {

            SpanText(
                text = "Zebra",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            WebImage(
                src = Resources.Images.STORY_ZEBRA,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Zebra"
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A zebra is a wild animal. It has a long face with tiny eyes. A zebra has white and black stripes on its body. Zebras run very fast.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Giraffe",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            WebImage(
                src = Resources.Images.STORY_GIRAFFE,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Giraffe"
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "I am a giraffe. I am a _________ animal. I only eat _________ leaves and grass.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "My _________ neck allows me to reach the leaves in the top of a tree.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "My legs are _________. I am a runner. I have a _________ pattern on my scree.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "House",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The house had a red _________ roof.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The walls of the house are _________. There was a _________ on one side of the roof. The door to the house was large and made of _________",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The windows were _________.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The house had two _________, a bathroom, a kitchen and a living room. The yard in front of _________ had a green lawn and tall _________.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}















